import PropTypes from 'prop-types';
import React, { useState } from 'react';

import useTranslation from '../../hooks/use_translation';
import Btn from '../framework/buttons/btn';
import Trans from '../translation/trans';

const ArticleQuickVersion = ({ content }) => {
	const { t } = useTranslation('component_article_quick_version');
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpanded = () => setIsExpanded(!isExpanded);

	return (
		<div className="card shadow-sm article-quick-version rounded-3 my-4">
			<div className="card-body">
				<p className="title-xsmall uppercase">{t('t1')}</p>
				<div className={`content ${isExpanded ? 'expanded' : 'collapsed'}`}>
					<Trans defaults={content} t={t} />
					{!isExpanded && <div className="fade-overlay"></div>}
				</div>
			</div>
			<div className=" card-footer">
				<Btn
					className="fw-500 text-dark"
					color="dark"
					component="button"
					fullWidth
					onClick={toggleExpanded}
					type="button"
					variant="link"
				>
					{isExpanded ? t('t2') : t('t3')}
				</Btn>
			</div>
		</div>
	);
};

ArticleQuickVersion.propTypes = {
	content: PropTypes.string.isRequired,
};

export default ArticleQuickVersion;
